import React from "react";
import { Input } from "../../../../../components/ui/input";
import {
	RadioGroup,
	RadioGroupItem,
} from "../../../../../components/ui/radio-group";
import { X } from "lucide-react";
import { BaseFieldPreviewProps } from "./previewUtils";
import {
	handleAddOption,
	handleRemoveOption,
	handleOptionLabelChange,
} from "./previewUtils";

const RadioFieldPreview: React.FC<BaseFieldPreviewProps> = ({
	field,
	renderDescription,
	onUpdateOptions,
	onUpdateField,
}) => {
	if (!field.options) return null;

	return (
		<div>
			{renderDescription()}
			<div className="space-y-2">
				<RadioGroup defaultValue="option1" disabled>
					{field.options.map((option: string, index: number) => (
						<div
							key={`option-${index}`}
							className="flex items-center"
						>
							<div className="flex items-center space-x-2 flex-1">
								<RadioGroupItem
									value={`option-${index}`}
									id={`option-${index}`}
									disabled
								/>
								{onUpdateOptions ? (
									<Input
										value={option}
										onChange={(
											e: React.ChangeEvent<HTMLInputElement>
										) =>
											handleOptionLabelChange(
												index,
												e.target.value,
												field.options!,
												onUpdateOptions
											)
										}
										className="flex-1"
									/>
								) : (
									<span>{option}</span>
								)}
							</div>
							{onUpdateOptions && (
								<button
									onClick={() =>
										handleRemoveOption(
											index,
											field.options!,
											onUpdateOptions
										)
									}
									className="text-gray-500 hover:text-gray-700 p-1"
									disabled={
										field.options &&
										field.options.length <= 2
									}
								>
									<X className="h-4 w-4" />
								</button>
							)}
						</div>
					))}

					{field.allowOther && (
						<div className="flex items-center">
							<div className="flex items-center space-x-2 flex-1">
								<RadioGroupItem
									value="__sonstiges__"
									id="__sonstiges__"
									disabled
								/>
								<span className="text-sm text-gray-700 w-24">
									Sonstiges
								</span>
								<Input
									disabled
									placeholder="Kurzantwort"
									className="flex-1"
								/>
							</div>
							{onUpdateField && (
								<button
									onClick={() =>
										onUpdateField({ allowOther: false })
									}
									className="text-gray-500 hover:text-gray-700 p-1"
									aria-label="Sonstiges-Option entfernen"
									data-testid="remove-sonstiges-option"
								>
									<X className="h-4 w-4" />
								</button>
							)}
						</div>
					)}
				</RadioGroup>

				{onUpdateOptions && (
					<div className="flex items-center mt-2 gap-3">
						<div className="flex items-center space-x-2 text-gray-500 cursor-pointer">
							<RadioGroup
								defaultValue="add-option"
								disabled
								className="inline-flex"
							>
								<RadioGroupItem
									value="add-option"
									id="add-option"
									disabled
								/>
							</RadioGroup>
							<span
								className="text-sm"
								onClick={() =>
									handleAddOption(
										field.options!,
										onUpdateOptions
									)
								}
							>
								Option hinzufügen
							</span>
						</div>
						{!field.allowOther && onUpdateField && (
							<>
								<span className="text-gray-400">oder</span>
								<button
									className="text-blue-600 hover:text-blue-700 text-sm"
									onClick={() =>
										onUpdateField({ allowOther: true })
									}
									aria-label="Sonstiges-Option hinzufügen"
									data-testid="add-sonstiges-option"
								>
									„Sonstiges" hinzufügen
								</button>
							</>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default RadioFieldPreview;
